module.exports = __webpack_public_path__ + "static/icon-96x96-0b1adfc84e5695d36cb82de4dc0eb285.png";